<mat-progress-bar *ngIf="isLoading" mode="indeterminate"></mat-progress-bar>

<mat-card>
  <mat-card-header>
    <h3>
      B2B Invoicing Counters for <ng-container *ngIf="company">{{company.name}}</ng-container>
    </h3>
  </mat-card-header>

  <div fxLayout="row" fxLayoutGap="10px" *ngIf="company">
    <div fxFlex="40">
      <button mat-raised-button color="primary" class="mr-1" (click)="goToPrevMonth()">{{ prevMonth | number: '2.0-0' }}/{{ prevMonthYear}}</button>
      <button mat-raised-button color="primary" class="mr-1" (click)="goToNextMonth()">{{ nextMonth | number: '2.0-0' }}/{{ nextMonthYear}}</button>
    </div>
    <div fxFlex></div>
    <div fxFlex="60" style="text-align: right;">

      <ng-container *ngIf="company == null || !company.customerNumber">
        <span (click)="goToCompanyEdit()" style="background-color: yellow; color: red;">Set the customer number of the company first!</span>
      </ng-container>
      <button mat-raised-button [disabled]="company == null || !company.customerNumber" color="blue" (click)="goToCreateInvoice()">Create Invoice for {{month | number: '2.0-0'}}/{{year}}</button>

    </div>

  </div>




  <ng-container *ngIf="counters?.companyCounters">
  <table mat-table [dataSource]="counters.companyCounters">

    <ng-container matColumnDef="month">
      <th mat-header-cell *matHeaderCellDef> Month </th>
      <td mat-cell *matCellDef="let element"> {{element.month}} </td>
    </ng-container>

    <ng-container matColumnDef="year">
      <th mat-header-cell *matHeaderCellDef> Year </th>
      <td mat-cell *matCellDef="let element"> {{element.year}} </td>
    </ng-container>

    <ng-container matColumnDef="code">
      <th mat-header-cell *matHeaderCellDef> Type </th>
      <td mat-cell *matCellDef="let element"> {{element.code}} </td>
    </ng-container>

    <ng-container matColumnDef="numberOfActions">
      <th mat-header-cell *matHeaderCellDef> Number </th>
      <td mat-cell *matCellDef="let element"> {{element.numberOfActions }} </td>
    </ng-container>

    <ng-container matColumnDef="amount">
      <th mat-header-cell *matHeaderCellDef> Amount </th>
      <td mat-cell *matCellDef="let element" class="text-right"> {{element.amount | number: '1.2-2'}} </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>


  </table>
  </ng-container>


</mat-card>


